import { Link } from "react-router-dom";

export default function BackToTopButton() {
  return (
    <Link to="#" className="back-to-top">
      <i className="fal fa-angle-up"></i>
    </Link>
  );
}
